module.exports = __webpack_public_path__ + "first-10-uv.jpg?9b6fb69a2cd893b5e57238f8fe6490f4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10-uv.jpg
// module id = 409
// module chunks = 0